"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_TRUST_LEVEL = void 0;
exports.BASE_TRUST_LEVEL = 30;
//# sourceMappingURL=petami.js.map